$(document).ready(function(){
  // 	image scrolling banner
 
  // Play with this value to change the speed
  let tickerSpeed = 1.3;

  let flickity = null;
  let isPaused = false;
  const slideshowEl = document.querySelector('.js-img-scrolling');
  if(slideshowEl){
    var scrollNav = slideshowEl.dataset.nav;
    var autoscrolling = slideshowEl.dataset.autoscrolling;
    var options = {};
  
    const update = () => {
      if (isPaused || autoscrolling == 'true') return;
      if (flickity.slides) {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
        flickity.selectedIndex = flickity.dragEndRestingSelect();
        flickity.updateSelectedSlide();
        flickity.settle(flickity.x);
      }
      window.requestAnimationFrame(update);
    };
  
    const pause = () => {
      isPaused = true;
    };
  
    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };
  
    if(scrollNav == 'true'){
      options = {
        autoPlay: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25
      }
    }else{
    	options = {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25
      }
    }
    
    flickity = new Flickity(slideshowEl, options);
    flickity.x = 0;
  
  
    slideshowEl.addEventListener('mouseenter', pause, false);
    slideshowEl.addEventListener('focusin', pause, false);
    slideshowEl.addEventListener('mouseleave', play, false);
    slideshowEl.addEventListener('focusout', play, false);
  
    flickity.on('dragStart', () => {
    	isPaused = true;
    });
  
    update();
  }


  // Stop autoplay after 5 seconds
  const stopAutoplayAfterTime = (pauseFunction, seconds) => {
    setTimeout(() => {
      pauseFunction(); 
    }, seconds * 1000);
  };

  // Start autoplay after a specified delay
  const startAutoplayAfterDelay = (playFunction, delay) => {
    setTimeout(playFunction, delay * 1000);
  };

  let tickerSpeed2 = 0.8;

  let flickity2 = null;
  let isPaused2 = false;
  const slideshowEl2 = document.querySelector('.js-img-scrolling-2');

  let isAutoplayStarted2 = false; // Flag to check if autoplay has started
  const scrollYTriggerValue2 = 10; // Set the scroll Y value at which autoplay should start

  if(slideshowEl2){
    var scrollNav = slideshowEl2.dataset.nav;
    var autoscrolling = slideshowEl2.dataset.autoscrolling;
    var options = {};
  
    const update2 = () => {
      if (isPaused2 || autoscrolling == 'true') return;
      if (flickity2.slides) {
        flickity2.x = (flickity2.x - tickerSpeed2) % flickity2.slideableWidth;
        flickity2.selectedIndex = flickity2.dragEndRestingSelect();
        flickity2.updateSelectedSlide();
        flickity2.settle(flickity2.x);
      }
      window.requestAnimationFrame(update2);
    };
  
    const initializeFlickity = (wrapAround) => {
      if (flickity2) {
        flickity2.destroy(); // Destroy the existing instance before reinitializing
      }
  
      let flickityOptions = {
        autoPlay: false,
        prevNextButtons: scrollNav === 'true',
        pageDots: false,
        draggable: true,
        wrapAround: wrapAround, // Pass wrapAround option dynamically
        selectedAttraction: 0.015,
        friction: 0.25
      };
  
      flickity2 = new Flickity(slideshowEl2, flickityOptions);
      flickity2.x = 0; // Set initial position
  
      flickity2.on('dragStart', () => {
        isPaused2 = true;
      });
    };

    const pause2 = () => {
      isPaused2 = true;
      initializeFlickity(true);
      window.requestAnimationFrame(update2);
    };
  
    const play = () => {
      if (isPaused2) {
        isPaused2 = false;
        initializeFlickity(false);
        window.requestAnimationFrame(update2);
      }
    };
  
    if(scrollNav == 'true'){
      options = {
        autoPlay: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25
      }
    }else{
    	options = {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: false,
        selectedAttraction: 0.015,
        friction: 0.25
      }
    }
    
    // flickity2 = new Flickity(slideshowEl2, options);
    // flickity2.x = 1800;
  
  
    // // slideshowEl2.addEventListener('mouseenter', pause2, false);
    // // slideshowEl2.addEventListener('focusin', pause2, false);
    // // slideshowEl2.addEventListener('mouseleave', play, false);
    // // slideshowEl2.addEventListener('focusout', play, false);
  
    // flickity2.on('dragStart', () => {
    // 	isPaused2 = true;
    // });

    initializeFlickity(false)
  
    // update2();

    
    // Add scroll event listener to start autoplay when scroll Y is over the trigger value
    // window.addEventListener('scroll', () => {
    //   const scrollPosition = window.scrollY;

    //   console.log('scrollPosition2 --- ', scrollPosition)
    //   if (scrollPosition > scrollYTriggerValue2 && !isAutoplayStarted2) {
    //     const portfolio2 = document.querySelector('.sie-portfolio_2');
    //     portfolio2.style.visibility = 'visible';
    //     isAutoplayStarted2 = true;
    //     update2(); // Start autoplay when scroll Y is over the trigger value

    //     initializeFlickity(true)
    //     // stopAutoplayAfterTime(pause2, 10); // Stop autoplay after 5 seconds
    //   }
    // });

    const portfolio2 = document.querySelector('.sie-portfolio_2');
    portfolio2.style.visibility = 'visible';
    isAutoplayStarted2 = true;
    update2(); // Start autoplay when scroll Y is over the trigger value

    initializeFlickity(true)
    
    // // Stop autoplay for the first slider after 5 seconds
    // stopAutoplayAfterTime(pause2, 10);
  }
  


  // Second Flickity Slider - move from right to left
  let tickerSpeed1 = 0.8;

  let flickity1 = null;
  let isPaused1 = false;

  const slideshowEl1 = document.querySelector('.js-img-scrolling-1');

  let isAutoplayStarted = false; // Flag to check if autoplay has started
  const scrollYTriggerValue = 240; // Set the scroll Y value at which autoplay should start

  
  if(slideshowEl1) {
    var scrollNav = slideshowEl1.dataset.nav;
    var autoscrolling = slideshowEl1.dataset.autoscrolling;
    var options = {};
  
    const update1 = () => {
      if (isPaused1 || autoscrolling == 'true') return;
      if (flickity1.slides) {
        flickity1.x = (flickity1.x + tickerSpeed1) % flickity1.slideableWidth; // Change direction by increasing x
        flickity1.selectedIndex = flickity1.dragEndRestingSelect();
        flickity1.updateSelectedSlide();
        flickity1.settle(flickity1.x);
      }
      window.requestAnimationFrame(update1);
    };

    const initializeFlickity = (wrapAround) => {
      if (flickity1) {
        flickity1.destroy(); // Destroy the existing instance before reinitializing
      }
  
      let flickityOptions = {
        autoPlay: false,
        prevNextButtons: scrollNav === 'true',
        pageDots: false,
        draggable: true,
        wrapAround: wrapAround, // Pass wrapAround option dynamically
        selectedAttraction: 0.015,
        friction: 0.25
      };
  
      flickity1 = new Flickity(slideshowEl1, flickityOptions);
      flickity1.x = -1500; // Set initial position

      // if (wrapAround) {
      //   flickity1.x = -750;
      // }
  
      flickity1.on('dragStart', () => {
        isPaused1 = true;
      });
    };
  
    const pause1 = () => {
      // isPaused1 = true;
      initializeFlickity(true);
      // window.requestAnimationFrame(update1);     
    };
  
    const play1 = () => {
      if (isPaused1) {
        isPaused1 = false;
        initializeFlickity(false);
        window.requestAnimationFrame(update1);
      }
    };
  
    if(scrollNav == 'true'){
      options = {
        autoPlay: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25
      }
    }else{
    	options = {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: false,
        selectedAttraction: 0.015,
        friction: 0.25
      }
    }
    
    // flickity1 = new Flickity(slideshowEl1, options);
    // flickity1.x = -1500;
  
    // // slideshowEl1.addEventListener('mouseenter', pause1, false);
    // // slideshowEl1.addEventListener('focusin', pause1, false);
    // // slideshowEl1.addEventListener('mouseleave', play1, false);
    // // slideshowEl1.addEventListener('focusout', play1, false);
  
    // flickity1.on('dragStart', () => {
    // 	isPaused1 = true;
    // });
  
    initializeFlickity(false);

    // Add scroll event listener to start autoplay when scroll Y is over the trigger value
    // window.addEventListener('scroll', () => {
    //   const scrollPosition = window.scrollY;

    //   // console.log('scrollPosition --- ', scrollPosition)
    //   if (scrollPosition > scrollYTriggerValue && !isAutoplayStarted) {
    //     const portfolio1 = document.querySelector('.sie-portfolio_1');
    //     portfolio1.style.visibility = 'visible';
    //     isAutoplayStarted = true;
    //     update1(); // Start autoplay when scroll Y is over the trigger value
    //     initializeFlickity(true)
    //     // stopAutoplayAfterTime(pause1, 10); // Stop autoplay after 5 seconds
    //   }
    // });

    const portfolio1 = document.querySelector('.sie-portfolio_1');
    portfolio1.style.visibility = 'visible';
    isAutoplayStarted = true;
    update1(); // Start autoplay when scroll Y is over the trigger value
    initializeFlickity(true)
  }

  // $('body').on('click', 'a', function(e){
  //   e.preventDefault();

  //   var type = $(this).attr('data-anchor-type');
  //   var target = $(this).attr('href');

  //   if(type == 'true'){
  //     $('html, body').animate({
  //         scrollTop: $(target).offset().top
  //     }, 500);
  //   }else{
  //     window.location.href = target;
  //   }
  // })

  $('.js-size-chart-trigger').on('click', function(e){
    e.preventDefault();

    $('.product-size-chart').addClass('active');
    $('body').addClass('popup-enabled');
  })

  $('.js-link-popup').on('click', function(e){
    e.preventDefault();

    var target = $(this).attr('data-popup');

    $(target).addClass('active');
    $('body').addClass('popup-enabled');
  })

  $('.js-ajax-popup-content').on('click', function(e){
    e.preventDefault();

    var href = $(this).attr('data-href');
    var target = $(this).attr('data-popup');

    fetch(href)
    .then(response => response.text())
    .then(responseText => {
      const html = responseText;
      const newDom = new DOMParser().parseFromString(html, 'text/html');

      var rPage = $(newDom).find('.page');
      rPage.find('.theme-editor-scroll-offset').remove();
      rPage.find('.header__space').remove();
      rPage.find('#shopify-section-announcement-bar').remove();
      rPage.find('#shopify-section-header').remove();
      rPage.find('#shopify-section-popup').remove();
      rPage.find('#shopify-section-footer').remove();
      rPage.find('.page-transition').remove();

      $(target).addClass('active');
      $(target).find('.size-chart-content').empty().append(rPage.html());
      $('body').addClass('popup-enabled');

      // $("script.refresh-js").each(function(){
      //     var oldScript = this.getAttribute("src");
      //     $(this).remove();
      //     var newScript;
      //     newScript = document.createElement('script');
      //     newScript.type = 'text/javascript';
      //     newScript.src = oldScript;
      //     document.getElementsByTagName("head")[0].appendChild(newScript);
      // });

      newDom.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });

      //slide part
      if($('[data-slider]').length > 0){
        $('[data-slider]').removeClass('is-hidden').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          prevNextButtons: false,
          pageDots: false
        });
      }
    })
  })

  $('.size-chart-close').on('click', function(){
    $('.product-size-chart').removeClass('active');
    $('body').removeClass('popup-enabled');
  })

  $(document).mouseup(function (e){

    var container = $(".size-chart-container");

    if (!container.is(e.target) && container.has(e.target).length === 0){

      container.parent('.product-size-chart').removeClass('active');
      $('body').removeClass('popup-enabled');

    }
  });

  $('body').on('click', '.js-modal-popup', function(){
    const modalId = $(this).attr('data-modal');

    $(`#${modalId}`).fadeIn();
  })

  $('body').on('click', '.modal-close-button', function(){
    $(this).closest('.modal').hide();
  })

})